import { render } from "./PostingDataDiffPage.vue?vue&type=template&id=3d7d1882&scoped=true&ts=true"
import script from "./PostingDataDiffPage.vue?vue&type=script&lang=ts"
export * from "./PostingDataDiffPage.vue?vue&type=script&lang=ts"

import "./PostingDataDiffPage.vue?vue&type=style&index=0&id=3d7d1882&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d7d1882"]])

export default __exports__